<template>
  <div class="addbidLedger">
    <div class="tabWrap">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="110px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购事项" prop="projectId">
                    <el-select
                      v-model="dateForm.projectId"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeProject"
                    >
                      <el-option
                        v-for="item in projectIdList"
                        :key="item.projectId"
                        :label="item.projectName"
                        :value="item.projectId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目规模" prop="projectScale">
                    <el-select
                      v-model="dateForm.projectScale"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeProjectSubName"
                    >
                      <el-option
                        v-for="item in projectsubList"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购计划编号" prop="bidPlanId">
                    <el-select
                      v-model="dateForm.bidPlanId"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changebidPlanCode"
                    >
                      <el-option
                        v-for="item in bidPlanCodeList"
                        :key="item.id"
                        :label="item.bidPlanCode"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：">
                    <el-input
                      v-model="dateForm.bidPurchaseMethod"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预算控制价">
                    <el-input v-model="dateForm.estimatePrice"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预算控制价单位" prop="estimatePriceUnit">
                    <el-radio-group v-model="dateForm.estimatePriceUnit">
                      <el-radio
                        v-for="item in list"
                        :label="item.value"
                        :key="item.value"
                        style="width: 160px; margin: 10px 0"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="采购平台">
                    <!-- <el-input v-model="dateForm.bidPlatform"  ></el-input> -->
                    <el-input
                      type="textarea"
                      :rows="3"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.bidPlatform"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="响应/报价单位">
                    <el-button type="primary" @click="addBidPlan()"
                      >新建</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 20px">
                <el-col :span="24">
                  <el-table
                    ref="multipleTable"
                    :data="companyList"
                    :key="tableKey"
                    border
                    size="mini"
                    style="width: 88%; margin-left: 110px"
                  >
                    <!-- <el-table-column type="selection" width="54"></el-table-column> -->
                    <el-table-column
                      v-for="(item, index) in tableColumns"
                      :key="index"
                      :prop="item.class"
                      :label="item.labelName"
                      :sortable="item.sortEnable"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                      width="210"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          size="small"
                          @click="editBidPlan(scope.row)"
                          >修改</el-button
                        >
                        <el-button
                          type="text"
                          size="small"
                          @click="delBidPlan(scope.row, scope.$index)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="选拨时间" prop="bidStartTime">
                    <el-date-picker
                      v-model="dateForm.bidStartTime"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成交单位" prop="bidWinCompany">
                    <el-select
                      v-model="dateForm.bidWinCompany"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeCompany"
                    >
                      <el-option
                        v-for="item in companyList"
                        :key="item.companyName"
                        :label="item.companyName"
                        :value="item.companyName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="成交金额">
                    <el-input
                      v-model="dateForm.bidWinPrice"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成交金额单位" prop="bidWinPriceUnit">
                    <el-radio-group v-model="dateForm.bidWinPriceUnit">
                      <el-radio
                        v-for="item in list"
                        :label="item.value"
                        :key="item.value"
                        style="width: 160px; margin: 10px 0"
                        disabled
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dateForm.attachmentList"
            @saveUpdateFile="saveUpdateFile"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left; width: 60%; margin-top: 20px"
        >
          <addApproveLine
            :addoredit="editFlag"
            :itemId="bidLedgerId || 0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="dateForm.approveTemplateType"
            :subApproveName="dateForm.approveTemplateName || ''"
          ></addApproveLine>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="savebidplanInfo">保 存</el-button>
      <el-button type="info" @click="close">取 消</el-button>
    </div>
    <!-- 添加采购计划弹窗 -->
    <addPlanDialog ref="addPlanDialog" @submitBtn="addBidPlans" />
  </div>
</template>

<script>
import {
  saveBidLedger, //新增采购台账接口
  updateBidLedger, //更新采购台账接口
  getprojectGeneral, //获取一条采购计划信息
  getBidLedgerdetail, //获取一条采购台账信息
  getProjects, //获取采购计划里的项目
  getBidPlanNos, //根据项目部获取采购计划下拉框数据
  getSubProjects, //根据采购计划编号获取工程分项下拉框数据
} from "@/services/bidServices";
import addPlanDialog from "./addPlanDialog"; //添加采购台账弹窗

export default {
  name: "addbidLedger",
  components: {
    addPlanDialog,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      // approveType: "bidmanager", //审批流类型
      // approveClass: "BID_JOIN_LEDGER",
      tableKey: Math.random(),
      editFlag: false, //false：新建 true：编辑
      projectIdList: [], //所属项目下拉框
      bidPlanCodeList: [], //采购计划编号下拉框
      projectsubList: [], //工程分项名称
      bidLedgerId: "", //存储id
      dateForm: {
        // id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        // commitDeptName: "", //提报部门
        // commitDeptId: "", //提报部门
        projectScale: "", //采购计划事项
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "",
        bidPurchaseMethod: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        estimatePriceUnit: 1,
        bidStartTime: null, //成交时间
        bidWinCompany: "",
        bidWinPrice: 0,
        bidWinPriceUnit: 1,
        bidPlatform: "青岛路桥建设集团有限公司官网",
        bidCompanyList: [],
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: true,
      },
      companyList: [],
      list: [
        {
          value: 1,
          name: "万元",
        },
        {
          value: 0,
          name: "元",
        },
      ],
      tableColumns: [
        { class: "companyName", labelName: "响应/报价单位", sortEnable: false },
        {
          class: "offerPrice",
          labelName: "报价",
          sortEnable: false,
        },
        { class: "bidRemark", labelName: "选拨情况说明", sortEnable: false },
      ], //表格列
      rules: {
        bidPlanId: [
          { required: true, message: "请选择采购计划编号", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择采购事项", trigger: "change" },
          // {
          //   min: 1,
          //   max: 60,
          //   message: "长度在 1 到 60 个字符",
          //   trigger: "blur",
          // },
        ],

        projectScale: [
          { required: true, message: "请选择项目规模", trigger: "change" },
        ],
        bidPlatform: [
          { required: true, message: "请选择采购平台", trigger: "change" },
        ],
        bidStartTime: [
          { required: true, message: "请选择成交时间", trigger: "change" },
        ],
        bidWinCompany: [
          { required: true, message: "请选择成交单位", trigger: "change" },
        ],
        bidWinPrice: [
          { required: true, message: "请填写成交金额", trigger: "blur" },
          ,
          {
            pattern: /^[0-9,.]+$/,
            message: "只能输入数字",
            trigger: "change",
          },
        ],
        // bidWinPriceUnit
      },
    };
  },
  created() {
    this.dateForm.applyUserName = sessionStorage.getItem("name");
    this.getProject();
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 60;
    try {
      document.getElementsByClassName("addbidLedger")[0].style.height =
        ch + "px";
    } catch (error) {
      console.log("-- tableHeight error\n", error);
    }
    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 60;
        try {
          document.getElementsByClassName("addbidLedger")[0].style.height =
            ch1 + "px";
        } catch (error) {
          console.log("-- tableHeight error\n", error);
        }
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.dateForm.id = this.tabRouteParam?.id ?? 0;
      if (this.dateForm.id) {
        this.editFlag = true;
        //编辑 获取详情
        this.bidLedgerId = this.tabRouteParam.id;
        this.getDetail(this.bidLedgerId);
      }
    },
    getProject() {
      let param = {
        approveType: "bidLedger",
      };
      getProjects(param)
        .then((res) => {
          if (res.code == "10000000") {
            this.projectIdList = res.data || [];
          }
        })
        .catch(() => {});
    },
    //根据项目获取采购计划编号下拉框数据
    getbidPlanCodes() {
      let reqParam = {
        approveType: "bidLedger",
        projectId: this.dateForm.projectId,
        bidPlanItem: encodeURIComponent(this.dateForm.projectScale),
      };
      getBidPlanNos(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.bidPlanCodeList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //根据采购计划事项
    getProjectSubClass() {
      let reqParam = {
        approveType: "bidLedger",
        projectId: this.dateForm.projectId,
      };
      getSubProjects(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.projectsubList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },

    //切换项目名称，获取采购计划编号下拉框数据
    changeProject() {
      let index = this.projectIdList.findIndex(
        (item) => item.projectId === this.dateForm.projectId
      );
      if (index !== -1) {
        this.dateForm.projectName = this.projectIdList[index].projectName;
        // this.dateForm.commitDeptName = this.projectIdList[index].deptName;
        // this.dateForm.commitDeptId = this.projectIdList[index].commitDeptId;
      }
      this.projectsubList = [];
      this.dateForm.projectScale = "";
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (this.dateForm.projectId) this.getProjectSubClass();
    },
    changebidPlanCode() {
      if (!this.dateForm.projectId) return;
      if (!this.dateForm.bidPlanId) return;
      let index = this.bidPlanCodeList.findIndex(
        (item) => item.id === this.dateForm.bidPlanId
      );
      if (index !== -1) {
        this.dateForm.bidPlanCode = this.bidPlanCodeList[index].bidPlanCode;
      }
      this.getbidPlanInfo(this.dateForm.bidPlanId);
    },
    changeProjectSubName() {
      if (!this.dateForm.projectId) return;
      // let index = this.projectsubList.findIndex(
      //   (item) => item.projectSubName === this.dateForm.projectSubName
      // );
      // if (index !== -1) {
      //   this.dateForm.bidType = this.projectsubList[index].bidType;
      // }
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (!this.dateForm.projectScale) return;
      this.getbidPlanCodes();
    },
    getbidPlanInfo(id) {
      let param = {};
      param.bidPlanId = id;
      getprojectGeneral(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm.projectType = res.data.projectType;
            this.dateForm.estimatePrice = res.data.estimatePrice;
            this.dateForm.isDecisionBase = res.data.isDecisionBase.toString();
            this.dateForm.bidPlanMethodKey = res.data.bidPlanMethodKey;
            this.dateForm.bidPlanMethodValue = res.data.bidPlanMethodValue;
            this.dateForm.bidPurchaseMethod = res.data.bidPlanMethodValue;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    changeCompany() {
      let index = this.companyList.findIndex(
        (item) => item.companyName === this.dateForm.bidWinCompany
      );
      if (index !== -1) {
        this.dateForm.bidWinPrice = this.companyList[index].offerPrice;
        this.dateForm.bidWinPriceUnit = this.companyList[index].offerPriceUnit;
      }
    },

    /* 打开新增采购计划弹窗 */
    addBidPlan() {
      this.$refs.addPlanDialog.showDialog(); //this.row.id);
    },
    /* 编辑采购计划弹窗 */
    editBidPlan(row) {
      this.dateForm.bidWinCompany = "";
      this.dateForm.bidWinPrice = "";
      this.dateForm.bidWinPriceUnit = "";
      this.$refs.addPlanDialog.showDialog(row); //this.row.id);
    },
    delBidPlan(row, index) {
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        if (this.dateForm.bidWinCompany == row.companyName) {
          this.dateForm.bidWinCompany = "";
          this.dateForm.bidWinPrice = "";
          this.dateForm.bidWinPriceUnit = "";
        }
        this.companyList.splice(index, 1);
      });
    },
    addBidPlans(item) {
      if (item.ids) {
        let index = this.companyList.findIndex((em) => em.ids == item.ids);
        this.companyList[index] = item;
        this.tableKey = Math.random();
      } else {
        let idArr = this.companyList.map((item) => {
          return item.ids;
        });
        if (idArr && idArr.length > 0) item.ids = Math.max(...idArr) + 1;
        else item.ids = 1;
        this.companyList.push(item);
      }
    },
    // 提交基本信息
    savebidplanInfo() {
      this.$refs["ruleForm"].validate((valid) => {
        this.dateForm.bidCompanyList = this.companyList.map((item) => {
          delete item.ids;
          return item;
        });
        if (valid) {
          let msg = "您确定保存吗, 是否继续?";
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      if (!this.editFlag) {
        //新增采购台账
        saveBidLedger(this.dateForm)
          .then((res) => {
            if (res.code == 10000000) {
              this.$message.success("提交成功");
              this.close();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新采购台账
        // param.id = this.bidLedgerId;
        updateBidLedger(this.dateForm)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.$message.success("更新成功");
              this.close();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    clearDialogForm() {
      this.dateForm = {
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        // commitDeptName: "", //提报部门
        // commitDeptId: "", //提报部门
        projectScale: "", //采购计划事项
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "",
        bidPurchaseMethod: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        estimatePriceUnit: 1,
        bidStartTime: null, //成交时间
        bidWinCompany: "",
        bidWinPrice: 0,
        bidWinPriceUnit: 1,
        bidPlatform: "青岛路桥建设集团有限公司官网",
      };
    },
    close() {
      let that = this;
      if (!this.editFlag) {
        this.bus.$emit("tabClose", "bidLedgerAdd");
      } else {
        this.bus.$emit("tabClose", "bidLedgerEdit");
      }
      this.bus.$emit("navMenuChange", {
        routeId: "bidLedger",
      });

      this.clearDialogForm();
    },
    //获取一条信息
    getDetail(id) {
      let param = {};
      param.bidLedgerId = id;
      getBidLedgerdetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = { ...this.dateForm, ...res.data };
            this.companyList = res.data.bidCompanyList.map((em, index) => {
              em.ids = index + 1;
              return em;
            });
            this.getProjectSubClass();
            this.getbidPlanCodes();
            // this.dateForm.projectId = this.dateForm.projectId.toString();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    closeDialog() {
      this.applyUserDiaVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.addbidLedger {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px;
        // margin-top: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 110px);

          .el-input {
            width: 100%;
          }
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

.screenPanel {
  text-align: left;
  height: auto;
}

.el-form-item {
  margin-bottom: 14px;
}

.el-select {
  margin-right: 10px;
}

/deep/.el-tabs__item.is-top.is-active {
  margin-left: 20px;
}

/deep/ .el-container .el-main {
  height: auto;
}
.firstTab {
  width: 72%;
  margin-top: 20px;
}
@media only screen and(max-width:1610px) {
  .firstTab {
    width: 90%;
    margin-top: 20px;
  }
}
</style>
